/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="79.22"
        height="95.33"
        viewBox="0 0 79.22 95.33"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M23.61 22.21h-7.55a1.25 1.25 0 0 0-1.25 1.25v21.86a1.25 1.25 0 0 0 1.25 1.25h7.55a1.25 1.25 0 0 0 1.25-1.25V23.46a1.25 1.25 0 0 0-1.25-1.25Zm-1.25 2.5v19.36h-5V24.71ZM43.38 22.21h-7.55a1.25 1.25 0 0 0-1.25 1.25v21.86a1.25 1.25 0 0 0 1.25 1.25h7.55a1.24 1.24 0 0 0 1.25-1.25V23.46a1.24 1.24 0 0 0-1.25-1.25Zm-1.25 2.5v19.36h-5V24.71ZM63.16 22.21h-7.55a1.25 1.25 0 0 0-1.25 1.25v21.86a1.25 1.25 0 0 0 1.25 1.25h7.55a1.25 1.25 0 0 0 1.25-1.25V23.46a1.25 1.25 0 0 0-1.25-1.25Zm-1.25 2.5v19.36h-5V24.71Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M75.87 44.07H3.35A3.35 3.35 0 0 0 0 47.42V92a3.34 3.34 0 0 0 3.35 3.34h72.52A3.34 3.34 0 0 0 79.22 92V47.42a3.35 3.35 0 0 0-3.35-3.35Zm-72.52 2.5h72.52a.85.85 0 0 1 .85.85V92a.84.84 0 0 1-.85.84H3.35A.85.85 0 0 1 2.5 92V47.42a.85.85 0 0 1 .85-.85Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M19.91 1c-6 12-4.3 17.09 1.4 17.09S19.91 1 19.91 1"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="m19 .55-.18.37-.36.74-.34.72-.32.71-.15.35-.3.69-.13.34-.27.66-.25.66c-.08.21-.15.43-.23.64l-.21.62c-.06.21-.13.41-.19.61l-.17.6c-.11.39-.21.77-.29 1.14l-.11.6c0 .18-.07.36-.1.54l-.09.52-.06.51c-.55 4.89 1.52 7.57 6.06 7.57 1.95 0 3-1.39 3.18-3.58a20 20 0 0 0-.77-6.2c-.29-1.16-.65-2.39-1-3.64s-.83-2.45-1.26-3.59l-.32-.82-.26-.64A1 1 0 0 0 19 .55Zm.8 3 .23.64c.25.69.49 1.41.72 2.13.4 1.22.74 2.4 1 3.51a18.43 18.43 0 0 1 .73 5.55c-.11 1.27-.47 1.75-1.19 1.75-3.75 0-5.14-2.65-3.56-8.21l.18-.58L18 8l.21-.62q.23-.63.48-1.29l.27-.68.3-.7c.1-.24.2-.48.31-.72Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M39.68 1c-6 12-4.29 17.09 1.4 17.09S39.68 1 39.68 1"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="m38.79.55-.37.74-.34.73-.33.72c-.06.12-.11.23-.16.35l-.3.7-.29.68-.26.66c0 .11-.09.22-.13.33l-.24.65-.11.32-.21.62-.19.61-.18.6c-1.94 7-.06 10.83 5.4 10.83 2 0 3-1.39 3.19-3.58a20.4 20.4 0 0 0-.78-6.2c-.29-1.16-.64-2.39-1-3.64s-.83-2.45-1.26-3.59L41 1.52l-.36-.9a1 1 0 0 0-1.85-.07Zm.79 3 .23.64c.25.69.5 1.41.73 2.13.39 1.22.73 2.4 1 3.51a18.37 18.37 0 0 1 .72 5.55c-.1 1.27-.46 1.75-1.19 1.75-3.68 0-5.09-2.56-3.63-7.92l.17-.58c0-.19.12-.39.18-.59l.21-.62c.07-.21.15-.42.23-.64l.25-.65c0-.12.09-.23.13-.34l.28-.69.15-.35.32-.72Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M59.46 1c-6 12-4.3 17.09 1.4 17.09S59.46 1 59.46 1"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="m58.57.55-.19.37-.36.74c0 .12-.11.24-.17.36l-.33.72c0 .12-.1.23-.16.35l-.3.7-.28.68-.27.66c-.08.22-.17.44-.24.66l-.23.64c-.19.52-.35 1-.49 1.53l-.17.59a19.77 19.77 0 0 0-.63 3.45v.47c-.18 4.29 1.91 6.61 6.14 6.61 2 0 3-1.39 3.18-3.58a20 20 0 0 0-.77-6.2c-.29-1.16-.64-2.39-1-3.64-.32-1-.66-2-1-2.9l-.37-1-.21-.53-.26-.64a1 1 0 0 0-1.89-.04Zm.79 3 .23.64c.25.69.49 1.41.73 2.13.39 1.22.73 2.4 1 3.51a18.69 18.69 0 0 1 .72 5.55c-.11 1.27-.47 1.75-1.19 1.75-3.43 0-4.88-2.21-3.9-6.83l.12-.54.15-.55.16-.58.19-.59.2-.62c.08-.21.15-.42.23-.64l.25-.65c0-.11.09-.23.14-.34l.28-.69.15-.35.32-.72Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M45.72 65H48.69l.5.06h.25l.5.08h.26l.52.09h.26l.54.1.56.12.57.14.91.22 1 .26.68.19 1.08.32 1.16.35 1.25.38 1.82.58 2 .66 1.53.48 1 .29.92.28.89.25.85.23.82.22.39.1.78.19.75.17c.62.13 1.21.25 1.79.35l.69.11a30.23 30.23 0 0 0 4 .33h1v2.5a32.78 32.78 0 0 1-5.33-.36l-.73-.11c-.73-.12-1.48-.27-2.27-.45l-.79-.19L68 73l-.42-.11-.87-.23-.9-.25-.46-.14-.95-.28-1-.3-1.58-.5-3-1L58 70l-1.2-.37-1.12-.34-.7-.21-1-.28-.93-.25-.86-.21-.55-.13-.53-.12-.51-.1-.5-.1-.48-.08h-.24l-.38-.13h-.23l-.46-.05h-2.54c-3.13 0-5.48.93-9 3.45l-.64.46-.33.24-.68.52-.71.54-1.21 1c-4.94 3.85-7.86 5.37-11.91 5.37s-6.21-.78-9.8-2.91l-.63-.38c-3.5-2.12-5.5-2.88-9.12-2.93h-.41v-2.5c4.27 0 6.67.82 10.42 3l1 .61.73.42a13.63 13.63 0 0 0 7.8 2.15c2.86 0 5.13-1 8.6-3.5l.68-.51.72-.55 1.21-.94.77-.6.74-.56.36-.27.7-.51.67-.47C39.41 66 42.08 65 45.72 65Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'BirthdayCakeIcon';

export default Icon;
